import { useContext } from "react";
// import dynamic from "next/dynamic";
import Note from "components/formComponents/Note/Note";
import Button from "components/ui/buttons/Button/Button";
import { CurrencyContext } from "contexts/currency";
import { useCart } from "lib/hooks/useCart";

import PromoCodeEntry from "../PromoCode/PromoCodeSection";
import styles from "./CartSummary.module.scss";
// const SummaryLineItem = dynamic(() => import("./SummaryLineItem"));
import SummaryLineItem from "./SummaryLineItem";

export default function CartSummary({ onCheckoutClick, isCheckoutActive }) {
  const { cart } = useCart();
  const { items, experiences } = cart;

  const { currency } = useContext(CurrencyContext);

  // if (!items || !experiences) {
  //   return null;
  // }

  const handleCheckoutClick = async () => {
    // const checkoutResponse = await postCheckout();
    onCheckoutClick();
  };

  // const currentItemCount = items.length;

  const currentSubtotal =
    Array.isArray(items) && !!experiences
      ? items?.reduce((acc, item) => {
          const { id, people, duration } = item;

          // Strapi nests under .data.attributes — matching Cart.jsx
          const experience = experiences.find((experience) => {
            return (
              experience?.data?.attributes?.metadata?.experience_code?.toString() ===
              id.toString()
            );
          });

          // Bare `return` here would make the accumulator undefined and turn
          // the whole subtotal into NaN.
          if (!experience) {
            return acc;
          }

          const { currencies } = experience?.data?.attributes?.metadata ?? {
            currencies: {},
          };
          // Strapi stores currency keys lowercase (usd, eur, …)
          const currencyPrice = currencies?.[currency.code.toLowerCase()];

          if (!currencyPrice) {
            return acc;
          }

          const itemTotal = currencyPrice * people * duration;
          return acc + itemTotal;
        }, 0)
      : 0;

  const lineItems = items
    ? items.map((item) => {
        return (
          <SummaryLineItem
            key={`line-item-${item?.id}`}
            title={item?.product_metadata?.title}
            unitPrice={
              item?.product_metadata?.currencies?.[
                currency?.code?.toLowerCase()
              ]
            }
            people={item?.people}
            duration={item?.duration}
          />
        );
      })
    : [];

  return (
    <div className={`${styles.container}`}>
      <h2 className={`${styles.header}`}>Cart Summary</h2>
      <div className={`${styles.lineItems}`}>{lineItems}</div>
      <div className={`${styles.total}`}>
        <span>Total {currency.code.toUpperCase()} </span>
        <span>
          {currency.symbol}
          {new Intl.NumberFormat("en-US").format(currentSubtotal)}
        </span>
      </div>

      <Note
        text="No payment is required at this time. We will be in touch to confirm
        details and finalize your booking."
        contentClassNames={[styles.noteContent]}
      />

      <div className={`${styles.promoCodeContainer}`}>
        <PromoCodeEntry />
      </div>

      <div className={`${styles.actionsContainer}`}>
        <Button
          className={`${styles.checkoutButton} send-enquiry-button`}
          name="send-enquiry-button"
          fill="bright"
          onClick={handleCheckoutClick}
          disabled={isCheckoutActive}
        >
          Send Enquiry
        </Button>
      </div>
    </div>
  );
}
